/* eslint-disable max-statements */
import React from 'react';
import styles from './styles.module.scss';
import withScrollToTop from 'src/utils/withScrollToTop';
import Statistics from './Components/Statistics';
import Banner from './Components/Banner';
import RecentlyListed from './Components/RecentlyListed';
import RecentlyTraded from './Components/RecentlyTraded';
import { useTypedDispatch } from 'src/redux/utils';
import { fetchCosmeticConfigs } from '@profile/src/redux/remoteActions';

const HomePage = () => {
  const dispatch = useTypedDispatch();
  React.useEffect(() => {
    dispatch(fetchCosmeticConfigs());
  }, [dispatch]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Banner, null), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(Statistics, null), /*#__PURE__*/React.createElement(RecentlyListed, null), /*#__PURE__*/React.createElement(RecentlyTraded, null)));
};

export default withScrollToTop(HomePage);